import(/* webpackMode: "eager" */ "/var/www/vhosts/murakamicity.com/httpdocs/frontend/src/app/[lang]/account/template.js");
